<template>
  <div>
    <!-- 保单详情 -->
    <div v-loading.fullscreen.lock="loading"></div>
    <div class="IntroducedDetails" v-if="allshow">
      <!-- 保单卡片 -->
      <baodan-car class="baodanCar" :baodanDetail="baodanDetail" />
      <!-- 投保地块信息 -->
      <div class="toubaoMessage">
        <div class="buttonTwo">
          <el-button
            type="primary"
            size="default"
            @click="downloadEle()"
            class="fontWeight400"
            >下载电子保单</el-button
          >
          <el-button size="default" @click.native="goxzJs" class="defaultColor"
            >查看险种介绍</el-button
          >
        </div>

        <!-- 判断是否是理赔成功 理赔成功显示理赔信息 -->
        <div
          class="isSuccess"
          v-show="baodanDetail.insurePolicyStatus == 50 || false"
        >
          <div class="tite">理赔信息</div>
          <table width="100%">
            <tr class="rowH42">
              <td>赔案号 :</td>
              <td class="flex2Td">{{ baodanDetail.claimNo }}</td>
            </tr>
            <tr class="rowH42">
              <td>赔付金额 :</td>
              <td class="flex2Td">{{ baodanDetail.sumClaim }}元</td>
            </tr>
            <tr class="rowH42">
              <td>赔付时间 :</td>
              <td class="flex2Td">
                {{ baodanDetail.paymentDate | formatDate("yyyy-MM-dd ") }}
              </td>
            </tr>
          </table>
        </div>

        <!-- 保单信息 -->
        <div class="messageStatus">
          <table class="flexBottom">
            <tr class="rowH32">
              <td>保单状态:</td>
              <td
                class="bigFont flex2Td"
                :class="policyColor[baodanDetail.insurePolicyStatus]"
              >
                {{ setpolicy[baodanDetail.insurePolicyStatus] }}
              </td>
            </tr>
            <tr class="rowH32">
              <td>更新时间:</td>
              <td class="flex2Td">
                {{ baodanDetail.updateTime | formatDate("yyyy-MM-dd hh:mm") }}
              </td>
            </tr>
            <tr class="rowH32">
              <td>关联订单:</td>
              <td class="flex2Td">
                {{ baodanDetail.orderSn }}
              </td>
            </tr>
            <tr class="rowH32">
              <td>种植地块:</td>
              <td class="maxHeight flex2Td">
                <div
                  class="allLands"
                  v-for="item in baodanDetail.coFarmInsureOrderLandVOList"
                  :key="item.id"
                >
                  <span> {{ item.landName }} &nbsp; </span>
                  <span class="AcreMianJiself"
                    >({{ item.statisticsLandAcre }} 亩)</span
                  >
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaodanCar from "./BaodanCar.vue";
import { getdetailsInsure } from "@/api/request/snkd.produce";

import { policy_state } from "@/confing/map_tab.js";

export default {
  name: "IntroducedDetails",

  components: {
    BaodanCar,
  },
  data() {
    return {
      // 是否显示
      allshow: false,
      index: 0,
      title: "保单详情",
      setpolicy: policy_state,
      policyColor: {
        10: "colorHui",
        40: "colorHui",
      },
      // 加载
      loading: true,
      baodanDetail: {
        coFarmInsureOrderLandVOList: {},
        coInsureCompanyVO: {},
        coInsureVO: {},
      },
    };
  },
  created() {
    this.getdetailsInsure();
  },

  methods: {
    // 获取保单详情
    async getdetailsInsure() {
      this.loading = true;
      const { respCode, obj } = await getdetailsInsure({
        id: this.$route.query.id,
      });

      if (respCode === 0) {
        this.baodanDetail = obj;
      }
      this.loading = false;
      this.allshow = true;
    },
    goxzJs() {
      this.$router.push({
        name: "IntroducedJs",
        query: {
          id: this.baodanDetail.coInsureVO.id,
          name: this.baodanDetail.coInsureVO.insureName,
        },
      });
    },
    downloadEle() {
      window.open(this.baodanDetail.elecPolicyUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.IntroducedDetails {
  text-align: center;
  min-height: 850px;
  background-color: #fff;
  overflow: hidden;
}

.baodanCar {
  height: 672px;
  float: left;
  // padding-top: 50px;
  padding: 50px 40px 0 40px;
}

.toubaoMessage {
  padding-top: 50px;
  box-sizing: border-box;
  float: left;
  width: 500px;

  .buttonTwo {
    text-align: left;
  }

  .isSuccess {
    box-sizing: border-box;
    margin-top: 60px;
    padding: 20px;
    width: 437px;
    height: 192px;
    background-color: #eefff9;
    text-align: left;
    color: #666;
    .tite {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 600;
    }
    .rowH42 {
      line-height: 42px;
      display: flex;
      td {
        flex: 1;
      }
      .flex2Td {
        flex: 3;
      }
    }
    .rowH80 {
      line-height: 10px;
      display: flex;
    }
  }
}
.flexBottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  .rowH32 {
    display: flex;
    td {
      flex: 1;
    }
    .flex2Td {
      flex: 3;
    }
  }
}
.messageStatus {
  margin-top: 40px;
  text-align: left;
  color: #666666;
  .rowH32 {
    line-height: 32px;
    margin: 15px 0;
  }

  .bigFont {
    font-size: 22px;
    font-weight: 600;
    color: $--color-primary;
  }
  .colorHui {
    color: #666666;
  }
}
.maxHeight {
  padding-bottom: 50px;
}

.allLands {
  line-height: 30px;
  margin-bottom: 10px;
}
.AcreMianJiself {
  position: relative;
  color: #ccc;
}
.fontWeight400 {
  font-weight: 400;
}
</style>
